var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 6.16669H3.67832L8.08915 1.75586C8.16874 1.67899 8.23223 1.58703 8.2759 1.48536C8.31958 1.38369 8.34257 1.27434 8.34353 1.16369C8.34449 1.05305 8.3234 0.943312 8.2815 0.840899C8.2396 0.738485 8.17772 0.645442 8.09948 0.567198C8.02124 0.488954 7.92819 0.427076 7.82578 0.385175C7.72337 0.343275 7.61363 0.32219 7.50298 0.323152C7.39233 0.324113 7.28298 0.347102 7.18131 0.390776C7.07964 0.43445 6.98769 0.497935 6.91082 0.577527L1.07748 6.41086C0.921259 6.56713 0.833496 6.77906 0.833496 7.00003C0.833496 7.221 0.921259 7.43292 1.07748 7.58919L6.91082 13.4225C7.06799 13.5743 7.27849 13.6583 7.49699 13.6564C7.71548 13.6545 7.92449 13.5669 8.079 13.4124C8.23351 13.2579 8.32115 13.0489 8.32305 12.8304C8.32495 12.6119 8.24095 12.4014 8.08915 12.2442L3.67832 7.83336H18.3333C18.5543 7.83336 18.7663 7.74556 18.9226 7.58928C19.0789 7.433 19.1667 7.22104 19.1667 7.00003C19.1667 6.77901 19.0789 6.56705 18.9226 6.41077C18.7663 6.25449 18.5543 6.16669 18.3333 6.16669Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.d8241bd4aa847c3aeefe05c3dd245644.svg";
export { ForwardRef as ReactComponent };